// extracted by mini-css-extract-plugin
module.exports = {"component":"layout-picker_component__8_23r","layoutPickerItem":"layout-picker_layoutPickerItem__uUerd","isActive":"layout-picker_isActive__hwRFG"};